import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder } from "@simonbackx/simple-encoding";
export class OrderPrices extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.cartPrice = 0;
        this.deliveryCost = 0;
        this.warranty = 0;
        this.VAT = 0;
    }
    get totalWithVAT() {
        return this.subtotalWithoutVAT + this.VAT + this.warranty;
    }
    get totalWithoutVAT() {
        return this.subtotalWithoutVAT + this.warranty;
    }
    get subtotalWithoutVAT() {
        return this.cartPrice + this.deliveryCost;
    }
}
__decorate([
    field({ decoder: IntegerDecoder })
], OrderPrices.prototype, "cartPrice", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], OrderPrices.prototype, "deliveryCost", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], OrderPrices.prototype, "warranty", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 2 })
], OrderPrices.prototype, "VAT", void 0);
//# sourceMappingURL=OrderPrices.js.map